import { BillLineInstallmentStatus } from '@types'
import { MockFactory } from '@tino-frontend/mocks'
import { lineItemInstallment } from './installment'

const lineItemInstallmentReimbursedCopy = lineItemInstallment.build(
  {
    ...lineItemInstallment.source,
    id: 'line_item_id_01_reimbursed',
    metadata: {
      ...lineItemInstallment.source.metadata,
      installment_id: 'line_item_id_01_reimbursed',
      versions: [
        {
          invoice_total_amount_cents: 30000,
          invoice_num_installments: 3,
          installment_edited_at: '2023-12-01T00:00:00Z',
          installment_number: 1,
          installment_total_amount_cents: 10000,
          installment_settlement_date: '2023-12-01T00:00:00Z',
          installment_estimated_due_date: '2023-12-01',
          installment_internal_status: BillLineInstallmentStatus.Open,
        },
        {
          invoice_total_amount_cents: 30000,
          invoice_num_installments: 3,
          installment_edited_at: '2023-12-01T00:00:00Z',
          installment_number: 1,
          installment_total_amount_cents: 10000,
          installment_settlement_date: '2023-12-01T00:00:00Z',
          installment_estimated_due_date: '2023-12-01',
          installment_internal_status: BillLineInstallmentStatus.Reimbursed,
        },
      ],
      edition: {
        edited: true,
        canceled: false,
        reimbursed: true,
        lastEditionDate: '2023-12-01T00:00:00Z',
        newAmount: 30000,
        originalAmount: 30000,
      },
    },
  },
  { mergeArray: false }
)

export const lineItemInstallmentReimbursed = new MockFactory(
  lineItemInstallmentReimbursedCopy
)
